import type { HttpUploadProgressEvent } from '@angular/common/http';

import { createActions, ngrxEvent } from '@core/ngrx-legacy';

export const HttpActions = createActions('HttpActions', {
  uploadProgress: ngrxEvent<{ uuid: string; event: HttpUploadProgressEvent }>(),
});
